module.exports = __webpack_public_path__ + "static/media/buildIcon.9938fb3a.svg";